import { Badge, Card, Flex, Heading, Text } from '@radix-ui/themes'
import type { ComponentProps, ReactNode } from 'react'

export interface SectionCardProps {
  title: string
  badge?: string
  badgeColor?: ComponentProps<typeof Badge>['color']
  children: ReactNode
}

export const SectionCard = ({ title, badge, badgeColor = 'gray', children }: SectionCardProps) => (
  <Card>
    <Flex align="center" gap="2" mb="3">
      <Heading as="h2" size="3">
        {title}
      </Heading>
      {badge ? (
        <Badge color={badgeColor} variant="soft">
          {badge}
        </Badge>
      ) : null}
    </Flex>
    {children}
  </Card>
)

export interface PlannedItemsProps {
  intro: string
  items: readonly string[]
}

export const PlannedItems = ({ intro, items }: PlannedItemsProps) => (
  <Flex direction="column" gap="2">
    <Text size="2" color="gray">
      {intro}
    </Text>
    <ul className="list-disc space-y-1 pl-5">
      {items.map((item) => (
        <li key={item}>
          <Text size="2" color="gray">
            {item}
          </Text>
        </li>
      ))}
    </ul>
  </Flex>
)

export interface PlannedSectionCardProps {
  title: string
  badge: string
  items: readonly string[]
}

export const PlannedSectionCard = ({ title, badge, items }: PlannedSectionCardProps) => (
  <SectionCard title={title} badge={badge}>
    <PlannedItems intro="This section will show:" items={items} />
  </SectionCard>
)
